export const environment = {
    msalConfig: {
        auth: {
            clientId: 'e132d2c3-9306-42e3-8d9c-8d58e41f06f9',
            authority: 'https://login.microsoftonline.com/8a8d5251-8fbd-4209-b62b-0c1d895132ab'
        }
    },
    apiConfig: {
        scopes: ["d0828a32-ee88-409c-adef-c973d6e6c358/.default"],
        ddpaScopes: ["1ea0eacf-9f2c-4047-b096-64e774f145bb/.default"],
        uri: 'https://graph.microsoft.com/v1.0/me'
    },
    b2cPolicies: {
        clientId: 'df211e93-be63-4468-8cba-7e2a4d1700f3',
        names: {
            signUpSignIn: "B2C_1a_ddmo-tf-rp-oidc-ddpa"
        },
        authorities: {
            signUpSignIn: {
                authority: "https://ddmoproviderb2cnonprod.b2clogin.com/ddmoproviderb2cnonprod.onmicrosoft.com/b2c_1a_ddmo-tf-rp-oidc-ddpa"
            }
        },
        authorityDomain: "ddmoproviderb2cnonprod.b2clogin.com",
        logout: "https://identity-uat.deltadental.com/accounts/logout?delta=ddmo&returnTo=https://ddmoproviderb2cnonprod.b2clogin.com/ddmoproviderb2cnonprod.onmicrosoft.com/b2c_1a_ddmo-tf-rp-oidc-ddpa/oauth2/v2.0/logout?post_logout_redirect_uri=",
    },
    auth0Config: {
        clientIdInternal: 'ZQD9uIEH2AAaUF16zKqtCT4s9Zg6RabK',
        clientIdExternal: 'wGaPT2pTLW9fX1LiWWw2ZfRB9Kj3nb7O'
    },
    envType: 'qa',
    roleName: 'qa_portal_provider_relations',
    userApiUrl: 'https://api-nonprod.deltadentalmo.com/credentialing-api-qa/api',
    providerApiUrl: 'https://ddmo-dw-qa.ddmoapis.com/dw/providernetworks/api',
    credentialSearchApiUrl: 'https://ddmo-dw-qa.ddmoapis.com/dw/providernetworks/api',
    credentialGetApiUrl: 'https://api-nonprod.deltadentalmo.com/credentialing-transac-api-qa/api',
    validateNpiUrl: 'https://ddmo-dw-qa.ddmoapis.com/dw/external/api',
    redirect_uri_internal: "https://credentialing-qa.deltadentalmo.com//admin",
    redirect_uri_external: "https://credentialing-qa.deltadentalmo.com/landing",
    authTokenApi: "https://qa-auth.deltadentalmo.com",
    redirectUrlAfterRegister: 'https://providers-qa.deltadentalmo.com/login',
    redirectUrlSC: 'https://providers-qa.deltadentalsc.com/login',
    logOutUrl: 'https://qa-auth.deltadentalmo.com/v2/logout',
    overjetUrl: 'https://api-nonprod.deltadentalmo.com/overjet-api-qa/api',
    telemetricUrl: 'https://api-nonprod.deltadentalmo.com/credentialing-api-qa/api',
    userAuditUrl: 'https://ddmo-dw-qa.ddmoapis.com/dw/useraudit/api',
    TRIGGER_CREDENTIALING_REQUEST: "true",
    cmsApiUrl: 'https://api-nonprod.deltadentalmo.com/qa-providers-api/api',
    memberBenefitsUrl: "https://ddmo-dw-qa.ddmoapis.com/dw/benefits/api",

}